<template>
  <WBDVacancyListPage :props-organization="{id: this.$route.params.id}" />
</template>
<script>
import WBDVacancyListPage from '@/views/vacancy/list.vue'

export default {
  name: 'OrganizationVacancyTabComponent',
  components: { WBDVacancyListPage },
  data: () => ({}),
  computed: {},
  watch: {},
  async created () {
  },
  methods: {}
}
</script>

